import { getClient } from '@api/client';
import { graphql } from '@api/generated';

export const tenantRedirectUrlQuery = graphql(`
  query tenantRedirectUrl($id: ID!, $path: String!) {
    tenantRedirectUrl(id: $id, path: $path)
  }
`);

/**
 * Queries API for a tenant redirect URL by id
 * @param id
 * @param path
 * @returns URL
 */
async function getTenantRedirectUrl(id: string, path: string): Promise<string> {
  const { data, error } = await getClient().query({
    query: tenantRedirectUrlQuery,
    variables: { id, path },
    fetchPolicy: 'network-only',
  });

  if (error) {
    throw new Error(error.message);
  }

  return data.tenantRedirectUrl;
}

export default getTenantRedirectUrl;
